// src/Dashboard.js
import * as React from 'react';
import { Card, CardContent, CardHeader } from '@mui/material';

const Dashboard = () => (
    <Card>
        <CardHeader title="Welcome to the Admin Dashboard" />
        <CardContent>
            Use this dashboard to manage ISP Mobile App Content.
        </CardContent>
    </Card>
);

export default Dashboard;
